import { render, staticRenderFns } from "./TeacherInteviewDialog.vue?vue&type=template&id=75abb43c&"
import script from "./TeacherInteviewDialog.vue?vue&type=script&lang=ts&"
export * from "./TeacherInteviewDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports